<template>
  <div
    class="kpb-banner"
    :style="`background-image: url(${data.backgroundImage}); --kpb-banner-background-size: ${backgroundSize}; --kpb-banner-background-position: ${backgroundPosition}; --kpb-banner-background-color: ${backgroundColor}`"
  >
    <slot name="top" />
    <slot />
    <slot name="bottom" />
  </div>
</template>

<script>
/**
 * Banner component. Can be used for hero banners, call to action banners etc.
 */
export default {
  props: {
    data: Object,
    backgroundSize: {
      type: String,
      default: 'cover',
    },
    backgroundPosition: {
      type: String,
      default: 'center',
    },
    backgroundColor: {
      type: String,
      default: '#fafafa',
    },
  },
}
</script>

<style lang="scss">
.kpb-banner {
  background-size: var(--kpb-banner-background-size);
  background-position: var(--kpb-banner-background-position);
  background-repeat: no-repeat;
  background-color: var(--kpb-banner-background-color);
}
</style>
